module.exports = __webpack_public_path__ + "9be9c8a6798f75b05aa34f2f9ddc0ffc.png";